var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolanaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1450_18270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9588 10.1288L10.6382 11.5239C10.6095 11.5542 10.5747 11.5784 10.5361 11.5949C10.4975 11.6114 10.4559 11.6199 10.4138 11.6199H4.15332C4.12344 11.6199 4.09422 11.6113 4.06924 11.5952C4.04426 11.579 4.02461 11.556 4.01271 11.5291C4.0008 11.5021 3.99716 11.4723 4.00222 11.4433C4.00729 11.4143 4.02084 11.3873 4.04122 11.3658L5.36286 9.97074C5.39149 9.94052 5.42612 9.9164 5.46459 9.8999C5.50307 9.88338 5.54457 9.87483 5.58654 9.87476H11.8467C11.8766 9.87476 11.9058 9.88336 11.9308 9.89949C11.9557 9.91563 11.9754 9.9386 11.9873 9.96558C11.9992 9.99257 12.0029 10.0224 11.9978 10.0514C11.9927 10.0804 11.9792 10.1073 11.9588 10.1288ZM10.6382 7.31949C10.6095 7.28919 10.5747 7.26502 10.5361 7.24851C10.4975 7.23201 10.4559 7.22349 10.4138 7.22352H4.15332C4.12344 7.22352 4.09422 7.23211 4.06924 7.24825C4.04426 7.26438 4.02461 7.28735 4.01271 7.31433C4.0008 7.34132 3.99716 7.37115 4.00222 7.40015C4.00729 7.42914 4.02084 7.45605 4.04122 7.47757L5.36286 8.87266C5.39149 8.90288 5.42612 8.92699 5.46459 8.9435C5.50307 8.96001 5.54457 8.96857 5.58654 8.96863H11.8467C11.8766 8.96863 11.9058 8.96004 11.9308 8.9439C11.9557 8.92777 11.9754 8.9048 11.9873 8.87782C11.9992 8.85083 12.0029 8.821 11.9978 8.792C11.9927 8.76301 11.9792 8.7361 11.9588 8.71458L10.6382 7.31949ZM4.15332 6.31739H10.4138C10.4559 6.31741 10.4975 6.3089 10.5361 6.29239C10.5747 6.27588 10.6095 6.25171 10.6382 6.22141L11.9588 4.82632C11.9792 4.8048 11.9927 4.77789 11.9978 4.7489C12.0029 4.7199 11.9992 4.69008 11.9873 4.66309C11.9754 4.63611 11.9557 4.61313 11.9308 4.597C11.9058 4.58086 11.8766 4.57227 11.8467 4.57227H5.58654C5.54457 4.57234 5.50307 4.58089 5.46459 4.5974C5.42612 4.61391 5.39149 4.63802 5.36286 4.66825L4.04156 6.06334C4.0212 6.08483 4.00765 6.11171 4.00258 6.14067C3.9975 6.16964 4.00111 6.19944 4.01298 6.22641C4.02484 6.25339 4.04444 6.27636 4.06937 6.29252C4.0943 6.30868 4.12347 6.31732 4.15332 6.31739Z",
    fill: "url(#paint0_linear_1450_18270)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1450_18270",
    x1: 4.67529,
    y1: 11.7878,
    x2: 11.1296,
    y2: 4.40116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8752F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5497D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#43B4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#28E0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#19FB9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1450_18270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 7.04762,
    fill: "white",
    transform: "translate(4 4.57227)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaIcon);
export default __webpack_public_path__ + "static/media/Solana-icon.aa036b0070d0e365a4a06859b3173b88.svg";
export { ForwardRef as ReactComponent };